import * as React from "react";

import {
  ProminentErrorMessageBox,
  ProminentErrorMessageBox_PresentationTypes,
} from "../../prominent-error";

import {
  ONE_TIME_PASSWORD_SEND_CODE_ERROR_MAX_RETRIES_EXCEEDED_MESSAGE,
  ONE_TIME_PASSWORD_SEND_CODE_SUCCESSFUL_SPECIAL_MESSAGE_FOR_STEP_2,
  useOneTimePasswordSendCode,
  useOneTimePasswordSendCodeForm,
  useOneTimePasswordUserExperience,
  useProminentError,
} from "../../providers";

export const OneTimePasswordProminentErrorMessageBox: React.FunctionComponent =
  (props) => {
    const { prominentError } = useProminentError();

    const { handleClose } = useOneTimePasswordUserExperience();

    const { data } = useOneTimePasswordSendCode();

    const { form: sendCodeForm } = useOneTimePasswordSendCodeForm();

    const dontRenderMessageAsHtmlWithJquery = React.useMemo(() => {
      if (
        prominentError ===
          ONE_TIME_PASSWORD_SEND_CODE_ERROR_MAX_RETRIES_EXCEEDED_MESSAGE ||
        prominentError ===
          ONE_TIME_PASSWORD_SEND_CODE_SUCCESSFUL_SPECIAL_MESSAGE_FOR_STEP_2
      ) {
        return true;
      }
      return false;
    }, [prominentError]);

    const prominentErrorPresentationType = React.useMemo(() => {
      if (
        prominentError ===
        ONE_TIME_PASSWORD_SEND_CODE_ERROR_MAX_RETRIES_EXCEEDED_MESSAGE
      ) {
        return ProminentErrorMessageBox_PresentationTypes.WARNING;
      }
      if (
        prominentError ===
        ONE_TIME_PASSWORD_SEND_CODE_SUCCESSFUL_SPECIAL_MESSAGE_FOR_STEP_2
      ) {
        return ProminentErrorMessageBox_PresentationTypes.SUCCESS;
      }
      return undefined;
    }, [prominentError]);

    const handleSignInViaFullOnActualPassword: React.MouseEventHandler<HTMLAnchorElement> =
      React.useCallback(
        (event) => {
          event.preventDefault();
          handleClose();
        },
        [handleClose]
      );

    const specialProminentMessageIfAny = React.useMemo(() => {
      if (
        prominentError ===
        ONE_TIME_PASSWORD_SEND_CODE_SUCCESSFUL_SPECIAL_MESSAGE_FOR_STEP_2
      ) {
        return (
          <React.Fragment>
            <span>{`We have sent a new code to `}</span>
            <span className="emphasised-special-text">{`${sendCodeForm.email}`}</span>
            <span>{` (`}</span>
            <span>{`${data?.data?.sendOtpCode?.retriesLeftForThisUser}`}</span>
            <span>{` attempts remaining).`}</span>
          </React.Fragment>
        );
      }

      if (
        prominentError ===
        ONE_TIME_PASSWORD_SEND_CODE_ERROR_MAX_RETRIES_EXCEEDED_MESSAGE
      ) {
        return (
          <React.Fragment>
            <span>{`You have sent too many codes to the email address you specified. If you don’t see the codes, they may have been sent to spam or your email may not be associated with a Bed Bath N’ Table account. Please try `}</span>
            <a
              onClick={handleSignInViaFullOnActualPassword}
            >{`signing in via password`}</a>
            <span>{` or `}</span>
            <a href="/contact-us">{`contact support`}</a>
            <span>{`.`}</span>
          </React.Fragment>
        );
      }

      return null;
    }, [
      sendCodeForm,
      data,
      prominentError,
      handleSignInViaFullOnActualPassword,
    ]);

    return (
      <ProminentErrorMessageBox
        dontRenderMessageAsHtmlWithJquery={dontRenderMessageAsHtmlWithJquery}
        presentationType={prominentErrorPresentationType}
      >
        {specialProminentMessageIfAny}
      </ProminentErrorMessageBox>
    );
  };
